
























































































































































































































































































































































declare var window: any;
import { Vue, Component, Prop } from 'vue-property-decorator';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import Datepicker from 'vuejs-datepicker';
import { vxm } from '@/store.vuex';
import moment from 'moment';
@Component({
  name: 'SkillCheckList',
  components: {
    Datepicker,
    ConfirmationModal,
  },
})
export default class SkillCheckList extends Vue {
  $moment: any;
  @Prop() skill;
  @Prop() isGuidedSignupPage;
  $wlToastr: any;
  private showValidationIcon = false;
  private confirmationCheck = false;
  private certifiedDate = new Date();
  private certifiedDisplayDate = '';
  private certifiedBy = '';

  mounted() {
    this.showValidationIcon = false;
    vxm.users.fetchSkillQuestions(this.skill.skillTypeId);
    this.certifiedDisplayDate = this.$moment(this.certifiedDate).format(
      vxm.jobs.getCompanyDateFormat.toUpperCase(),
    );
    this.certifiedBy = vxm.users.CheckListCertifiedBy
      ? vxm.users.CheckListCertifiedBy
      : vxm.users.myUserProfile.getFullName();
  }

  closeWindow() {
    this.confirmationCheck = false;
    this.$modal.hide('skill-certification-modal');
    vxm.users.getProfileStrength();
  }

  continueToCertify() {
    if (this.validateChecklistAnswers()) {
      this.$modal.show('skill-certification-modal');
    } else {
      this.showValidationIcon = true;
      setTimeout(() => this.scrollUpError(), 500);
      this.$wlToastr('error', 'Please select all required questions');
    }
  }

  get questionCheckList() {
    return vxm.users.QuestionCheckList;
  }

  get checkListMetaData() {
    return vxm.users.CheckListMetaData;
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  get certificationText() {
    return vxm.configs.getGlobalConfigValue('CANDIDATE_PORTAL_SKILL_CHECKLIST_CERTIFY')
  }

  get authorizationText() {
    return vxm.configs.getGlobalConfigValue('CANDIDATE_PORTAL_SKILL_CHECKLIST_AUTHORIZE')
  }

  getToolTipMessage(type, option) {
    console.log(type, option);
    if (type === 'PROFICIENCY') {
      if (option == 1) {
        return this.checkListMetaData['Proficiency']['01'];
      } else if (option == 2) {
        return this.checkListMetaData['Proficiency']['02'];
      } else if (option == 3) {
        return this.checkListMetaData['Proficiency']['03'];
      } else if (option == 4) {
        return this.checkListMetaData['Proficiency']['04'];
      }
    } else if (type === 'FREQUENCY') {
      if (option == 1) {
        return this.checkListMetaData['Frequency']['01'];
      } else if (option == 2) {
        return this.checkListMetaData['Frequency']['02'];
      } else if (option == 3) {
        return this.checkListMetaData['Frequency']['03'];
      } else if (option == 4) {
        return this.checkListMetaData['Frequency']['04'];
      }
    }
  }

  setSelectedAnswer(event, questionID, answerID, linkedQuestionId = null) {
    vxm.users.setSelectedAnswer({ questionID, answerID, linkedQuestionId });
  }

  radioOptionClicked(event, question, option, linkedQuestionId = null) {
    //do Operations if checklist is not completed
    //if selected option is checked uncheckit
    if (!linkedQuestionId && this.isChecked(question, option) === 'checked') {
      console.log('type of question is ', typeof question);
      this.setSelectedAnswer(
        event,
        question.questionID,
        null,
        linkedQuestionId,
      );
    } else if (
      linkedQuestionId &&
      this.isChecked(question.linkedQuestion[0], option) === 'checked'
    ) {
      this.setSelectedAnswer(
        event,
        question.questionID,
        null,
        linkedQuestionId,
      );
    }
  }

  submitSkillCheckListAnswer(type) {
    if (this.confirmationCheck) {
      if (this.certifiedBy) {
        this.saveSkillCheckListAnswer(type);
      } else {
        this.$wlToastr(
          'error',
          'Please enter full name ',
          'Applicant Signature',
        );
      }
    } else {
      this.$wlToastr(
        'error',
        'Click on checkbox to certify and authorize',
        'Certification',
      );
    }
  }

  async saveSkillCheckListAnswer(type) {
    try {
      if (type === 'submit') {
        await vxm.users.saveSkillCheckListAnswer({
          skillId: this.skill.skillTypeId,
          type,
          certifiedBy: this.certifiedBy,
          certifiedDate: this.certifiedDate,
        });
      } else {
        await vxm.users.saveSkillCheckListAnswer({
          skillId: this.skill.skillTypeId,
          type,
          certifiedBy: null,
          certifiedDate: null,
        });
      }

      this.$wlToastr(
        'success',
        this.$t('skill-answers-saved-message'),
        this.$t('saved.successfully'),
      );
      this.closeModal();
      vxm.users.getProfileStrength();
      vxm.users.getSkills();
    } catch (e) {
      this.$wlToastr('error', e);
    }
  }

  closeModal() {
    if (this.isGuidedSignupPage === 'true') {
      this.$router.push({
        name: 'GuidedSignup',
        params: { openSection: 'skills' },
      });
    } else {
      this.$router.push({ path: '/myprofile/v2/skills' });
    }
  }

  isChecked(question, option) {
    if (
      question.userQuestionResponse &&
      question.userQuestionResponse.userAnswerList &&
      question.userQuestionResponse.userAnswerList[0] === option.masterID
    ) {
      return 'checked';
    } else {
      return '';
    }
  }

  canShowValidationIcon(question) {
    return (
      this.showValidationIcon &&
      ((question.questionRequired &&
        question.userQuestionResponse &&
        question.userQuestionResponse.userAnswerList &&
        !question.userQuestionResponse.userAnswerList.length) ||
        (question.linkedQuestion[0].questionRequired &&
          !question.linkedQuestion[0].userQuestionResponse.userAnswerList
            .length))
    );
  }

  scrollUpError() {
    let el = document.querySelector('.error-border');
    if (el != null) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  validateChecklistAnswers() {
    let isAnsweredRequiredQuestions = true;
    vxm.users.QuestionCheckList.forEach((template) => {
      template.questionList.forEach((question) => {
        if (
          question.questionRequired &&
          !question.userQuestionResponse.userAnswerList[0]
        ) {
          isAnsweredRequiredQuestions = false;
        }
        question.linkedQuestion.forEach((linkedQuestion) => {
          if (
            linkedQuestion.questionRequired &&
            !linkedQuestion.userQuestionResponse.userAnswerList[0]
          ) {
            isAnsweredRequiredQuestions = false;
          }
        });
      });
    });
    return isAnsweredRequiredQuestions;
  }

  confirmExitSkillChecklist() {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('confirm-are-you-sure-title'),
        body: this.$t('skill-confirm-exit-without-saving'),
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          this.closeModal();
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  get isCompleted() {
    /* if (this.skill.skillCheckList === '02') {
      return true;
    } else {
      return false;
    }*/
    return false;
  }
}
